import PhaserNavMeshPlugin from "./phaser-navmesh-plugin";
import PhaserNavMesh from "./phaser-navmesh";

export default PhaserNavMeshPlugin;
export { PhaserNavMesh };
